export default {
  adms: {
    link: {
      create_title: "Установка связи",
      create_ok: "Связать",
      create_cancel: "Отмена"
    },    
    licenseWarningLink: "<center><red>Внимание: продукт не лицензирован!</red> <companyLink>{{company}}</companyLink> не несёт ответственности за качество работы ПО.</center>",
    licenseWarning: "<center><red>Внимание: продукт не лицензирован!</red> Разработчик не несёт ответственности за качество работы ПО.</center>",
    licenseWarningLinkUrl: "https://www.e-projecting.ru/sa",
    companyName: "Разработчик"
  }  
}
